export default function formDataToObj(formData) {
    const final = {}
    const keys = Object.keys(formData)
    keys.forEach(key => {
        if (/\[.*\]/.test(key)) {
            let k = key.split(/[[\]]/)
            final[k[0]] = final[k[0]] || []
            final[k[0]].push(formData[key])
        }
        else final[key] = formData[key]
    })
    return final
}